/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import moment from 'moment';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
};

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class ArchiveAccountSuccess extends React.Component<*> {
  componentDidMount() {
    //archived_at not returned !!!
    //const dateObj = new Date(this.props.actionDrawerStore.response.updated_at);
    const dateObj: Date = new Date();
    const momentObj: any = moment(dateObj);
    const updDate: any = momentObj.format('YYYY-MM-DD hh:mm:ss');
    this.props.accountStore.details.details.archived_at = updDate; // eslint-disable-line camelcase
  }

  render(): React.Node {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const { currentAccountDetails, t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.archived')}</h3>
            <p>{t('general:trading_accounts.messages.archived')}:</p>
          </div>
          <div className={styles['archive-account-details']}>
            <React.Fragment>
              <b>{t('general:trading_account')}:</b>
              <ul>
                {
                  <li>
                    {/* <b>{t('general:trading_account')}: </b> */}
                    {actionDrawerStore.response.name}
                  </li>
                }
                {
                  <li>
                    {/* <b>{t('general:trading_accounts.labels.number')}: </b> */}
                    {actionDrawerStore.response.account_no}
                  </li>
                }
              </ul>
            </React.Fragment>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
